module.exports = __webpack_public_path__ + "img/54_15.06bdd117.png";